import { isTesting, macroCondition } from '@embroider/macros';
import { type BrowserHistory, createBrowserHistory, createMemoryHistory } from 'history';
import { BrowserRouter, unstable_HistoryRouter as HistoryRouter } from 'react-router';

export const browserHistory: BrowserHistory = macroCondition(isTesting())
  ? createMemoryHistory()
  : createBrowserHistory();

export const ReactRouter = macroCondition(isTesting()) ? HistoryRouter : BrowserRouter;
